import React, { useMemo } from 'react'
import { Grid } from '@material-ui/core'
import { useFormContext } from 'react-hook-form'

import Select from '_components/inputs/Select'
import Autocomplete from '_components/inputs/Autocomplete'

import useStyles from './styles'

const FilterField = ({ name, label, type, options }) => {
  const styles = useStyles()
  const { watch } = useFormContext()

  const currentValue = watch(name)

  const formattedOptions = useMemo(() => {
    if (options && options.length > 0 && typeof options[0] === 'string') {
      return options.map(option => ({ value: option, label: option }))
    }
    return options
  }, [options])

  const renderField = () => {
    if (name === 'category' || name === 'tradesman_work_city') {
      return (
        <Autocomplete
          name={name}
          label={label}
          options={
            name === 'category'
              ? formattedOptions?.slice()?.sort((a, b) => a.label.localeCompare(b.label))
              : formattedOptions
          }
          getOptionLabel={option => option.label}
          defaultValue={Array.isArray(currentValue) ? currentValue : []}
        />
      )
    }

    if (type === 'select') {
      return (
        <Select
          name={name}
          label={label}
          options={formattedOptions}
          getValue={option => option.value}
          getLabel={option => option.label}
          getKey={option => option.value}
          defaultValue={currentValue || ''}
        />
      )
    }
    return null
  }

  return <Grid className={styles.fieldContainer}>{renderField()}</Grid>
}

export default FilterField
